var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "t-gen-form" },
    [
      _c(
        "el-row",
        { attrs: { gutter: _vm.formConfCopy.gutter } },
        [
          _c(
            "el-form",
            {
              ref: _vm.formConfCopy.formRef,
              attrs: {
                disabled: _vm.formConf.disabled,
                "label-position": _vm.formConfCopy.labelPosition,
                "label-width": _vm.formConfCopy.labelWidth + "px",
                model: _vm.formModel,
                rules: _vm.formRules,
                size: _vm.formConfCopy.size,
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            _vm._l(_vm.formConfCopy.fields, function (item, index) {
              return _c("generate-form-item", {
                key: item.key + "_" + index,
                style: _vm.isFieldShow(item),
                attrs: {
                  cid: item.vModel,
                  index: index,
                  item: item,
                  models: _vm.formModel,
                  rules: _vm.formRules,
                  "seq-no": _vm.getSeqNo(index, item),
                  pageShowMore: _vm.pageShowMore,
                  btnStyle: _vm.formConfCopy.theme,
                },
                on: {
                  "update:models": function ($event) {
                    _vm.formModel = $event
                  },
                  next: _vm.nextPage,
                  prev: _vm.prevPage,
                  "input-change": _vm.onInputChange,
                  "ocr-success": _vm.handleOcrSuccess,
                },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }